import React from 'react';
import "./footer.css"


const Footer = () => {

    return (
        <div>
           <div className='footer'>
                <h6 className='f-16 fw-700 mb-0'>حق کپی رایت محفوظ می‌باشد، طراحی و پیاده سازی توسط خودمون</h6>
            <div>
                <div className='info d-flex align-items-center gap-2'>
                    <h6 className='d-flex align-items-center f-14 fw-400 mb-0'><i className="pi pi-phone mx-2" style={{ color: '#669D24',backgroundColor: '#fff',padding: '3px',borderRadius: '4px' ,fontWeight: '700'}}></i> شماره تماس: 67572-021</h6>
                    <h6 className='d-flex align-items-center f-14 fw-400 mb-0'><i className="pi pi-envelope mx-2" style={{ color: '#669D24',backgroundColor: '#fff',padding: '3px',borderRadius: '4px',fontWeight: '700' }}></i> ایمیل: benicejuice@gmail.com </h6>
                </div>
            </div>
           </div>
        </div>
    );
}

export default Footer;
